import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteCountryAwardJudge: (
  fetchContext: FetchContext,
  awardJudgeId: number,
  countryId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, awardJudgeId, countryId, accessToken) => {
  const searchParams = new URLSearchParams();
  searchParams.append('countryId', countryId.toString());

  return fetch(
    `${fetchContext.baseUrl}/api/staff/award-judges/${awardJudgeId}?${searchParams}`,
    {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    },
  ).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete country award judge'));
};
